/** Production origin for Lucimark Book (advertiser portal). */
export const LUCIMARK_BOOK_PORTAL_PUBLIC_ORIGIN = 'https://book.lucimark.com'

/** Max listing photos per bookable screen. */
export const MARKETPLACE_MAX_PORTAL_PHOTOS_PER_PLAYER = 5

/** Default caption under the booking QR on portal-bookable player idle screens. */
export const DEFAULT_PLAYER_BOOKING_QR_CTA = 'Escaneie para reservar no Lucimark Book'

/** Max length for {@link DEFAULT_PLAYER_BOOKING_QR_CTA} overrides in portal billing settings. */
export const MARKETPLACE_PLAYER_BOOKING_QR_CTA_MAX_LENGTH = 120

/** Default quote validity (hours) after CPS quote — P0-5. */
export const MARKETPLACE_QUOTE_EXPIRY_HOURS = 24

/** @deprecated Use {@link MARKETPLACE_QUOTE_EXPIRY_HOURS}. */
export const MARKETPLACE_QUOTE_TTL_HOURS = MARKETPLACE_QUOTE_EXPIRY_HOURS

/** Inventory hold TTL after submit-for-review uses {@link computeReviewHoldExpiryHours} from SLA. */
export const MARKETPLACE_INVENTORY_HOLD_HOURS = 48

/** Inventory hold TTL after all operators approve (payment window). */
export const MARKETPLACE_PAYMENT_TTL_HOURS = 72

/** Advertiser decision window after a mixed review outcome (P0-Gap-1). */
export const MARKETPLACE_PARTIAL_APPROVAL_DECISION_TTL_HOURS = 72

/** Synthetic user id for auto-publish of Book fulfillment playlists. */
export const MARKETPLACE_FULFILLMENT_PUBLISH_USER_ID = 'lucimark-book-fulfillment'

/**
 * Legacy fulfillment metadata id for retired `Book idle` auto-playlists.
 * House fill uses `house_content_playlist_urn` directly on the per-player Book service list.
 * Creating new idle service playlists for `portal_bookable` screens is forbidden — see docs/architecture.md.
 */
export const MARKETPLACE_PORTAL_IDLE_AD_ORDER_ID = '__lucimark_portal_idle__'

/**
 * `distribution_list.portal_ad_order_id` for each bookable screen's Book service list (1:1 with player).
 * House + order CPS playlists are rows on that list. Excluded from `proofOfPlayOrderId`.
 */
export const MARKETPLACE_PORTAL_SERVICE_AD_ORDER_ID = '__lucimark_portal_service__'

/** Max RPC attempts per shard before marking failed (P0-Gap-3). */
export const MARKETPLACE_FULFILLMENT_MAX_ATTEMPTS = 3

/** Backoff between fulfillment RPC retries (ms): 1s, 5s, 30s. */
export const MARKETPLACE_FULFILLMENT_RETRY_DELAYS_MS = [1_000, 5_000, 30_000] as const

/** Paid orders with non-terminal shards escalate after this window (ms). */
export const MARKETPLACE_STALLED_FULFILLMENT_MS = 30 * 60 * 1000

/** Re-run shards left in `fulfilling` after a worker timeout (ms). */
export const MARKETPLACE_STALE_FULFILLING_MS = 5 * 60 * 1000

/** Advertiser-declared image creative duration bounds (seconds). */
export const MARKETPLACE_IMAGE_CREATIVE_DURATION_MIN_SECONDS = 1
export const MARKETPLACE_IMAGE_CREATIVE_DURATION_MAX_SECONDS = 60

/** Max duration reserved on Cloudflare Stream direct uploads for advertiser video transcode. */
export const MARKETPLACE_CREATIVE_STREAM_MAX_DURATION_SECONDS = 600

/** Payment reminder emails fire at these offsets (hours) before `hold_expires_at`. */
export const MARKETPLACE_PAYMENT_REMINDER_OFFSETS_HOURS = [48, 24, 4] as const
